import styles from '@/styles/app.module.scss';
import Nav from "@/components/nav/nav";
import StatusFooter from "@/components/status-footer/status-footer";
import { Outlet } from "react-router-dom";
import AuthPage from './pages/auth/auth';
import { connect } from 'react-redux';
import { RootState } from './store';
import { Spinner } from 'react-bootstrap';
import MessagesComponent from '@/components/messages/messages';
import AuthPendingPage from './pages/auth/pending/pending';

interface Props {
  authenticated: boolean;
  authentication_pending: boolean;
  azure_token: string | null;
  loading: boolean;
  loadingText: string;
}

function mapStateToProps(state: RootState): Props {
  return {
      authenticated: state.auth.authenticated,
      azure_token: state.auth.azure_token,
      authentication_pending: state.auth.azure_token !== null && state.auth.token === null,
      loading: state.loading.loading,
      loadingText: state.loading.loadingText
  };
}

function App(props: Props) {
  return (
    <>
      {
        !props.authenticated && !props.authentication_pending && <AuthPage />
      }
      {
        !props.authenticated && props.authentication_pending && <AuthPendingPage />
      }
      {
        props.authenticated && (
          <>
            <Nav />

            <div className={styles.main}>
                <div style={{ flex: 1 }}>
                    <Outlet />
                </div>

                {
                  props.loading && (
                    <div className={styles.spinner}>
                      <Spinner size="sm"></Spinner>
                      <div className="ps-3">
                        { props.loadingText }
                      </div>
                    </div>
                  )
                }

                {
                  <MessagesComponent />
                }
                <StatusFooter />
            </div>
          </>
        )
      }
    </>
  );
}

export default connect(mapStateToProps)(App);
